import React, { useEffect } from "react";
import Scaffold from "../../../widget/layouts/Scaffold";
import { MainBodyContainer } from "../../../widget/common/ui/MainContainer";
import AppTranslation from "../../../service/app_translation/AppTranslation";
import ChatActions from "./widget/ChatActions";
import { ResponsiveDeviceType } from "../../../widget/layouts/ScreenMedia";
import { ChatsContextProvider } from "../../../provider/chats/chats/chats/ChatsContextProvider";
import ChatsScreenBody from "./ChatsScreenBody";
import { ConversationHeaders } from "../widget/chat_conversation/ConversationHeaders";
import { TeamChatsContextProvider } from "../../../provider/chats/chats/team_chats/TeamChatsContextProvider";
import { DepartmentChatsContextProvider } from "../../../provider/chats/chats/department_chats/DepartmentChatsContextProvider";
import { GroupChatsContextProvider } from "../../../provider/chats/chats/group_chats/GroupChatsContextProvider";
import SessionStorage from "../../../service/storage/SessionStorage";
import StorageKeys from "../../../const/StorageKeys";
import DashboardLayout from "../../dashboard/DashboardLayout";
import { loadGoogleMapsScript } from "../../../libraries/google_map/LoadGoogleMapsScript";

const ChatsScreen = () => {
  const type: number = ResponsiveDeviceType();

  useEffect(() => {
    if (type < 3) {
      SessionStorage.deleteValue(StorageKeys.chats_conversation_detail);
    } else {
      loadGoogleMapsScript()
        .then(() => {
          console.log("Google Maps loaded");
        })
        .catch(console.error);
    }
    // eslint-disable-next-line
  }, []);

  return (
    <ChatsContextProvider>
      <TeamChatsContextProvider>
        <DepartmentChatsContextProvider>
          <GroupChatsContextProvider>
            {type === 3 ? (
              <Scaffold
                appBarTitle={AppTranslation.text("chats")}
                appBarAction={<ChatActions />}
                chatProfile={type === 3 ? <ConversationHeaders /> : undefined}
                className="chats-main"
              >
                <ChatsScreenBody type={type} />
              </Scaffold>
            ) : (
              <DashboardLayout
                title={AppTranslation.text("chats")}
                navIndex={2}
                actions={<ChatActions />}
                className="chats-main"
              >
                <MainBodyContainer className="h-100">
                  <ChatsScreenBody type={type} />
                </MainBodyContainer>
              </DashboardLayout>
            )}
          </GroupChatsContextProvider>
        </DepartmentChatsContextProvider>
      </TeamChatsContextProvider>
    </ChatsContextProvider>
  );
};

export default ChatsScreen;
export const routeName: string = "/chats";
